import { Navigate, useLocation } from 'react-router-dom'
import { DEFAULT_LANG, isSupportedLang } from '../../i18n'

export function LanguageRedirect() {
  const location = useLocation()

  const stored = localStorage.getItem('i18nextLng')
  const browserLang = navigator.language?.split('-')[0]

  const lang = (stored && isSupportedLang(stored))
    ? stored
    : (browserLang && isSupportedLang(browserLang))
      ? browserLang
      : DEFAULT_LANG

  // Preserve the current path when redirecting (e.g., /privacy -> /fr/privacy)
  const currentPath = location.pathname === '/' ? '/' : location.pathname
  return <Navigate to={`/${lang}${currentPath === '/' ? '/' : currentPath}`} replace />
}
